var BlockView = require('views/block/base-block-view');

var HeaderView = BlockView.extend({
  className: 'headers',
  play: function() {
    this.readyToGo();
  }
});

module.exports = HeaderView;